//以下两个常量 只能同时有一个为true
export const USE_CAIYUN = false
export const USE_HEFENG = false
export const USE_GAODE = true

export const API_HEFENG_KEY = '28a50843d4374244bef6a3597774c7d9'
export const API_CAIYUN_KEY = 'gDDBL8jpwEO3MrTB'
export const API_GAODE_KEY = '6657ce532af7e1ba869148dff59e8b35'

export const LOCATION_ID = 101010100
export const LOCATION = '116.41,39.92'

export const CITY_CODE = '370214'

export function getBaseUrl() {
    if (USE_HEFENG) {
        return process.env.VUE_APP_BASE_HEFENG_API
    }
    if(USE_GAODE){
        return process.env.VUE_APP_BASE_GAODE_API
    }
    //彩云api 测试环境需要跨域设置
    return process.env.NODE_ENV == 'development' ? '/caiyunapi' : process.env.VUE_APP_BASE_CAIYUN_API
}

